import type { ReactNode } from "react";

// Layout das telas de autenticação — réplica exata da estrutura de
// login.tsx / register.tsx / confirm-email.tsx do app original:
// fundo surface-alt, px-28, hero badge (ponto dourado + BOLÃO PGA em
// letterspacing 2), título 36 bold, subtítulo 14 com opacity .6.
type Props = {
  title: string;
  subtitle: string;
  children: ReactNode;
};

export function AuthLayout({ title, subtitle, children }: Props) {
  return (
    <div className="min-h-full bg-surface-alt text-surface-alt-foreground">
      <div className="mx-auto flex min-h-dvh max-w-lg flex-col px-7 pt-12 pb-10">
        <div className="mb-5 flex items-center gap-2">
          <span className="h-2 w-2 rounded-full bg-accent" />
          <span className="text-[11px] font-bold tracking-[2px] text-accent">
            BOLÃO PGA
          </span>
        </div>

        <h1 className="text-4xl font-bold">{title}</h1>
        <p className="mt-2 mb-8 text-sm leading-5 text-surface-alt-foreground/60">
          {subtitle}
        </p>

        {children}
      </div>
    </div>
  );
}
